module.exports = __webpack_public_path__ + "img/PD1506441834547773440.4e16fc84.png";